import React from 'react';

const StudentInfo = ({ student }) => {
    if (!student) return null;

    return (
        <div className="bg-white rounded-2xl shadow-lg p-6 mb-6 border border-[#0d4f5c]/20 hover:shadow-xl transition-shadow duration-300">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-14">
                <div className="flex items-center gap-4 w-full md:w-auto">
                    <div className="w-16 h-16 bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] rounded-full flex items-center justify-center text-white shadow-lg flex-shrink-0">
                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                    </div>
                    <div className="flex-1 min-w-0">
                        <h2 className="text-xl md:text-2xl font-bold text-gray-800 truncate">{student.name}</h2>
                        <p className="text-sm text-gray-500 truncate">{student.course}</p>
                    </div>
                </div>
                <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-4 text-sm w-full">
                    <div className="bg-gray-50 rounded-lg p-3">
                        <p className="text-xs text-gray-500 font-medium uppercase tracking-wider">Enrollment No</p>
                        <p className="font-semibold text-gray-700">{student.enrollmentNo}</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3">
                        <p className="text-xs text-gray-500 font-medium uppercase tracking-wider">Exam</p>
                        <p className="font-semibold text-gray-700">{student.examName}</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-3">
                        <p className="text-xs text-gray-500 font-medium uppercase tracking-wider">Semester</p>
                        <p className="font-semibold text-gray-700">{student.semester}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentInfo;